// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"page-map_wrapper__tZl6Y","blob":"page-map_blob__zMfIr","grid":"page-map_grid__18jg4","item":"page-map_item__GrloR","box":"page-map_box__sTOD8"};